<template>
  <div>
    <!-- 轮播图 -->
    <div class="carouselList">
      <el-carousel :interval="40000" type="card" height="420px">
        <el-carousel-item v-for="(item, index) in carouselList" :key="index">
          <h3 class="medium"><el-image :src="item"></el-image></h3>
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- 固定定位切换栏 -->
    <!-- <div class="tabsList" id="survey">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="概览" name="survey"></el-tab-pane>
        <el-tab-pane label="房东" name="landlord"></el-tab-pane>
        <el-tab-pane label="位置" name="site"></el-tab-pane>
        <el-tab-pane label="评价" name="evaluate"></el-tab-pane>
        <el-tab-pane label="设施" name="facility"></el-tab-pane>
      </el-tabs>
    </div> -->
    <div class="detailsList" v-if="hourseInfo.houseInfoSon">
      <div class="details_top" id="overview">
        <div
          v-if="hourseInfo.houseInfoSon.iToiletType == 1"
          class="details_title"
        >
          {{ hourseInfo.city }} | 整套出租
        </div>
        <div
          v-if="hourseInfo.houseInfoSon.iToiletType == 2"
          class="details_title"
        >
          {{ hourseInfo.city }} | 独立单间
        </div>
        <div
          v-if="hourseInfo.houseInfoSon.iToiletType == 3"
          class="details_title"
        >
          {{ hourseInfo.city }} | 合住房间
        </div>
        <div class="details_name">
          {{ hourseInfo.vHousTitle }}
        </div>
        <div class="details_tag">
          <el-tag v-for="(item, index) in label" :key="index">{{
            item
          }}</el-tag>
        </div>
        <div class="details_info">
          <div class="details_info_left">
            <div class="details_info_left_l">
              <img src="../../image/house.png" alt="" />
            </div>
            <div class="details_info_left_r" v-if="hourseInfo.houseInfoSon">
              <div
                class="details_info_left_r_top"
                v-if="hourseInfo.houseInfoSon.iToiletType == 1"
              >
                整租
              </div>
              <div
                class="details_info_left_r_top"
                v-if="hourseInfo.houseInfoSon.iToiletType == 2"
              >
                单间
              </div>
              <div
                class="details_info_left_r_top"
                v-if="hourseInfo.houseInfoSon.iToiletType == 3"
              >
                合租
              </div>
              <div class="details_info_left_r_bottom">
                面积：{{ hourseInfo.houseInfoSon.vHourseArea }}㎡
              </div>
            </div>
          </div>
          <div class="details_info_center">
            <div class="details_info_center_l">
              <img src="../../image/sofa.png" alt="" />
            </div>
            <div class="details_info_center_r">
              <div class="details_info_center_r_top">
                {{ hourseInfo.roomNumber }}间卧室
              </div>
              <div class="details_info_center_r_bottom">
                {{ hourseInfo.hallNumber }}厅{{ hourseInfo.kitchenNumber }}厨{{
                  hourseInfo.bathroomNumber
                }}卫
              </div>
            </div>
          </div>
          <div class="details_info_right">
            <div class="details_info_right_l">
              <img src="../../image/bed.png" alt="" />
            </div>
            <div class="details_info_right_r">
              <div class="details_info_right_r_top">
                可住{{ hourseInfo.houseFavour.iResidentNum }}人
              </div>
              <div class="details_info_right_r_bottom" v-for="item in hourseInfo.houseBedInfo" :key="item.vBedStyle">
                  {{item.pjName}}
              </div>

            </div>
          </div>
        </div>
      </div>
      <div
        class="details_bottom"
        v-if="
          hourseInfo.houseFavour.iNewSale == 1 ||
            hourseInfo.houseFavour.iLinkSale == 1 ||
            hourseInfo.houseFavour.iNightSale == 1
        "
      >
        <div class="discounts_title">
          优惠
        </div>
        <div class="discounts_list" v-if="hourseInfo.houseFavour.iNewSale == 1">
          <div class="discounts_list_left">
            <el-tag type="danger">新房促销</el-tag>
          </div>
          <div class="discounts_list_right">
            新房前3单首单支付享{{ hourseInfo.houseFavour.mNewCount }}折
          </div>
        </div>

        <div
          class="discounts_list"
          v-if="hourseInfo.houseFavour.iLinkSale == 1"
        >
          <div class="discounts_list_left">
            <el-tag type="danger">连住优惠</el-tag>
          </div>
          <div
            class="discounts_list_right"
            v-for="(item, index) in hourseInfo.houseRuleLink"
            :key="index"
          >
            {{ item.iLinkDays }}天以上{{ item.iLinkCount }}折优惠.
          </div>
        </div>
        <div
          class="discounts_list"
          v-if="hourseInfo.houseFavour.iNightSale == 1"
        >
          <div class="discounts_list_left">
            <el-tag type="danger">今夜特价</el-tag>
          </div>
          <div
            class="discounts_list_right"
            v-for="(item, index) in hourseInfo.houseRuleNight"
            :key="index"
          >
            {{ item.dNightStart }}:00~{{
              hourseInfo.houseFavour.iCheckEndTime
            }}:00预定，享受{{ item.iNightCount }}折优惠
          </div>
        </div>
      </div>
      <div class="landlord" id="landlord">
        <div class="landlord_title">房东</div>
        <div class="landlord_info">
          <div class="landlord_info_img">
            <img src="../../image/userimg.png" alt="" />
          </div>
          <div class="landlord_info_text">
            <div class="landlord_info_text_top">
              <!-- {{ hourseInfo.customer.customerName }} -->
            </div>
            <div class="landlord_info_text_bottom">实名认证丨共666套房源</div>
          </div>
          <div class="landlord_info_grade">
            <div class="landlord_info_grade_top">
              <div class="grade_top_list">房东服务 100分</div>
              <div class="grade_top_list">房源质量 100分</div>
              <div class="grade_top_list">房源竞争力 100分</div>
            </div>
            <div class="landlord_info_grade_bottom">
              <div class="grade_bottom_list">优秀</div>
              <div class="grade_bottom_list">优秀</div>
              <div class="grade_bottom_list">优秀</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 地图模块 -->
      <div class="housing_location" id="site">
        <div class="housing_location_title">房源位置</div>
        <div class="housing_location_map">
            <map-container ref="mapContainer" :mapConfig="mapConfig" :markerConfig="markerConfig"
                           :plugins="mapPlugins" :controlBar="controlBar" :toolBar="toolBar">

            </map-container>
<!--          <baidu-map class="map" :center="this.frameCenter" :zoom="this.zoom">
            &lt;!&ndash; 放大缩小 &ndash;&gt;
            <bm-navigation
              type="BMAP_NAVIGATION_CONTROL_SMALL"
              anchor="BMAP_ANCHOR_TOP_LEFT"
            ></bm-navigation>
            &lt;!&ndash; 标记点 &ndash;&gt;
            <bm-marker :position="this.frameCenter"> </bm-marker>
          </baidu-map>-->
          <div class="housing_location_map_box">
            <div class="housing_location_map_box_title">
              <div class="housing_location_map_box_title_top">
                {{ hourseInfo.city }}
              </div>
              <div class="housing_location_map_box_title_bottom">
                {{ hourseInfo.address }}{{ hourseInfo.location }}
              </div>
            </div>
            <div class="housing_location_map_box_tabs" v-if="mapInfo">
              <el-tabs
                v-model="activeNameother"
                @tab-click="handleClick"
                stretch
              >
                <el-tab-pane label="商圈" name="first">
                  <div
                    class="firstList"
                    v-for="(item1, index1) in mapInfo.businessList"
                    :key="index1"
                  >
                    <div class="firstList_top">
                      <div class="firstList_top_left">{{ index1 + 1 }}</div>
                      <div class="firstList_top_right">{{ item1.place }}</div>
                    </div>
                    <div class="firstList_bottom">
                      距离{{ item1.distance }}km
                    </div>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="学校" name="second">
                  <div
                    class="firstList"
                    v-for="(item2, index2) in mapInfo.schoolList"
                    :key="index2"
                  >
                    <div class="firstList_top">
                      <div class="firstList_top_left">{{ index2 + 1 }}</div>
                      <div class="firstList_top_right">{{ item2.place }}</div>
                    </div>
                    <div class="firstList_bottom">
                      距离{{ item2.distance }}km
                    </div>
                  </div>
                </el-tab-pane>
                <!-- <el-tab-pane label="医院" name="third">
                  <div
                    class="firstList"
                    v-for="(item3, index3) in mapInfo.hosptialList"
                    :key="index3"
                  >
                    <div class="firstList_top">
                      <div class="firstList_top_left">{{ index3 + 1 }}</div>
                      <div class="firstList_top_right">{{ item3.place }}</div>
                    </div>
                    <div class="firstList_bottom">
                      距离{{ item3.distance }}m
                    </div>
                  </div>
                </el-tab-pane> -->
                <el-tab-pane label="交通" name="third">
                  <div
                    class="firstList"
                    v-for="(item4, index4) in mapInfo.trafficlList"
                    :key="index4"
                  >
                    <div class="firstList_top">
                      <div class="firstList_top_left">{{ index4 + 1 }}</div>
                      <div class="firstList_top_right">{{ item4.place }}</div>
                    </div>
                    <div class="firstList_bottom">
                      距离{{ item4.distance }}km
                    </div>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>
        </div>
      </div>
      <!-- 评价 -->
      <div class="evaluate" id="evaluate">
        <div class="evaluate_title">评价</div>
        <div class="evaluate_info">
          <div class="evaluate_info_img">
            <img
              src="http://p2.qhimg.com/bdm/480_296_0/t0164fa7c75aa8a9742.jpg"
              alt=""
            />
          </div>
          <div class="evaluate_info_text">
            <div class="evaluate_info_text_top">超赞</div>
            <div class="evaluate_info_text_bottom">
              <el-rate v-model="value1" disabled></el-rate>
            </div>
          </div>
          <div class="evaluate_info_grade">
            <div class="evaluate_info_grade_top">
              <div class="grade_top_list">5.0</div>
              <div class="grade_top_list">5.0</div>
              <div class="grade_top_list">5.0</div>
              <div class="grade_top_list">5.0</div>
            </div>
            <div class="evaluate_info_grade_bottom">
              <div class="grade_bottom_list">整洁卫生</div>
              <div class="grade_bottom_list">描述相符</div>
              <div class="grade_bottom_list">交通位置</div>
              <div class="grade_bottom_list">服务周到</div>
            </div>
          </div>
          <div class="evaluate_total">
            共12条评价
          </div>
        </div>
        <div class="evaluate_list_box">
          <div
            class="evaluate_list"
            v-for="(item, index) in commentList.commentList"
            :key="index"
          >
            <div class="evaluate_list_userinfo">
              <div class="evaluate_list_userinfo_text">
                <div class="evaluate_list_userinfo_photo">
                  <img
                    src="http://browser9.qhimg.com/bdr/__85/t019fd908f724f51900.jpg"
                  />
                </div>
                <div class="evaluate_list_userinfo_name">
                  <div class="evaluate_list_userinfo_name_top">
                    {{ item.customer_id }}
                  </div>
                  <div class="evaluate_list_userinfo_name_bottom">
                    <el-rate v-model="value1" disabled></el-rate>
                  </div>
                  <div class="evaluate_num">5.0</div>
                </div>
              </div>
              <div class="evaluate_list_userinfo_time">{{ item.time }}</div>
            </div>
            <div class="evaluate_text">
              {{ item.vComment }}
            </div>
            <div class="evaluate_photos">
              <div
                class="QuickMark"
                v-for="(img, i) in item.imageUrls"
                :key="i"
                @click="getImg(img)"
              >
                <el-image
                  style="width: 100%; height: 100%"
                  :src="img"
                  :preview-src-list="srcList"
                >
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="more">
        展开更多评价<i
          class="el-icon-arrow-down
"
        ></i>
      </div> -->
      <!-- 服务设施 -->
      <div class="facility" id="facility">
        <div class="facility_title">服务设施</div>

        <div
          class="facility_list"
          v-for="(item, index) in serveList.children"
          :key="index"
        >
          <div class="facility_list_left">
            <div class="img">
              <img :src="item.meta.icon" />
              <div class="img_text">{{ item.label }}</div>
            </div>
          </div>
          <div class="facility_list_right">
            <div
              class="facility_list_rightList_box"
              v-for="(item2, index2) in item.children"
              :key="index2"
            >
              <div class="facility_list_rightList" v-if="item2.hidden == '1'">
                <div class="rightList_left">
                  <!-- v-if="demand.indexOf(item2.value.toString()) !== -1" -->
                  <img
                    v-if="item2.component == '1'"
                    src="../../image/facilityyes.png"
                  />
                  <img v-else src="../../image/facilityno.png" alt="" />
                </div>
                <div class="rightList_right">{{ item2.label }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 预定须知 -->
      <div class="service">
        <div class="service_title">预定须知</div>
        <div class="service_rule">
          <!-- 第一行 -->
          <div class="service_rule_list_one">
            <div class="unsubscribe">退订规则</div>
            <div class="service_rule_list_one_info">
              <div
                class="service_rule_list_info_title"
                v-if="hourseInfo.houseFavour.iCheckRule == 0"
              >
                <el-tag class="GS" effect="dark">宽松</el-tag>
                入住前1天12:00前退订，可获100%退款。之后退订不退款
              </div>
              <div
                class="service_rule_list_info_title"
                v-if="hourseInfo.houseFavour.iCheckRule == 1"
              >
                <el-tag effect="dark" class="SZ">适中</el-tag>
                入住前5天12:00前退订，可获100%退款。之后退订不退款
              </div>
              <div
                class="service_rule_list_info_title"
                v-if="hourseInfo.houseFavour.iCheckRule == 2"
              >
                <el-tag class="YG" effect="dark">严格</el-tag>
                入住前7天12:00前退订，可获100%退款。之后退订不退款
              </div>
              <div class="img">
                <img
                  v-if="hourseInfo.houseFavour.iCheckRule == 0"
                  src="../../image/KS.png"
                  alt=""
                />
                <img
                  v-if="hourseInfo.houseFavour.iCheckRule == 1"
                  src="../../image/SZ.png"
                  alt=""
                />
                <img
                  v-if="hourseInfo.houseFavour.iCheckRule == 2"
                  src="../../image/YG.png"
                  alt=""
                />
              </div>
            </div>
          </div>
          <!-- 第二行 -->
          <div class="service_rule_list_two">
            <div class="unsubscribe">入离时间</div>
            <div class="service_rule_list_two_info">
              <div class="service_rule_list_info_title">
                {{ hourseInfo.houseFavour.iCheckStartTime }}：00之后可入住，{{
                  hourseInfo.houseFavour.iCheckOutTime
                }}：00之前需退房
              </div>
            </div>
          </div>
          <!-- 第三行 -->
          <div class="service_rule_list_three">
            <div class="unsubscribe">预定时间</div>
            <div class="service_rule_list_three_info">
              <div class="service_rule_list_info_title">
                {{
                  hourseInfo.houseFavour.iCheckEndTime
                }}：00前可订当天，最少预定{{
                  hourseInfo.houseFavour.iMiniDays
                }}天，最多预定天数{{
                  hourseInfo.houseFavour.iMaxDays !== 0
                    ? hourseInfo.houseFavour.iMaxDays
                    : "不限"
                }}
              </div>
            </div>
          </div>
          <!-- 第四行 -->
          <div class="service_rule_list_four">
            <div class="unsubscribe">开<span></span>票</div>
            <div class="service_rule_list_four_info">
              <div class="invoice">
                平台开票
              </div>
              <div class="invoice_bottom">
                房东委托平台开具发票。<span>查看开票说明</span>
              </div>
            </div>
          </div>
          <!-- 第五行 -->
          <div class="service_rule_list_five">
            <div class="unsubscribe">房东要求</div>
            <div class="service_rule_list_five_info">
              <div v-for="(item, index) in demandList" :key="index">
                <div class="five_info_list">
                  <div class="five_info_list_left">
                    <img
                      v-if="demand&&demand.indexOf(item.value.toString()) !== -1"
                      src="../../image/yes.png"
                      alt=""
                    />
                    <img v-else src="../../image/no.png" />
                  </div>
                  <div class="five_info_list_right">{{ item.label }}</div>
                </div>
              </div>
            </div>
            <div class="notes">
              入住须知，预定前请仔细阅读，预定即默认规则。
            </div>
          </div>
        </div>
      </div>
      <!-- 价格说明 -->
      <div class="explain">
        <div class="explain_title">价格说明</div>
        <div class="explain_text">
          “划线价格为参考价，该价格指产品/服务的门市价、服务提供者的指导价、零售价、市场价或该产品/服务曾经展示过的销售价等，并非原价；由于产品/服务信息实时更新、服务提供者差异、市场价格波动等原因，该价格可能会与您预订时展示的不一致，仅供您参考。
          未划线价格指产品或服务的实时标价，该价格是在划线价基础上根据服务提供者让利、产品或服务参加活动、或会员使用优惠券的不同而计算出的优惠后的金额。具体成交价格以订单结算页价格准。”
        </div>
      </div>
      <!-- 附近同类好房 -->
      <div class="good_house">
        <div class="good_house_title">附近同类好房</div>
        <div class="good_house_list" v-for="item in 4" :key="item">
          <div class="good_house_list_img">
            <img
              src="https://test.youjiaminsu.cn:443/avatar/2023/05/27/c474d710-79bc-4da5-9697-86950e16dec1.jpg"
            />
          </div>
          <div class="good_house_info">整套1室 · 可住2人</div>
          <div class="good_house_info_name">
            已消毒/近地铁/黄鹤楼/太 子湖/武汉外语学院/武汉外语学院/武汉外语学院
          </div>
          <div class="price">
            ￥198<span>/晚</span>
            <div class="priceOther">￥666</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { houseListInfo } from "../../api/index";
import mapContainer from "@/components/map-container/map-container";
export default {
    components:{
        mapContainer
    },
  data() {
    return {
        mapPlugins:['AMap.ToolBar','AMap.ControlBar','AMap.AutoComplete'],//地图插件
        controlBar:{
            position:{
                top: '10px',
                left: '10px',
            }
        },
        toolBar:{
            position:{
                top: '105px',
                left: '40px',
            }
        },
        mapConfig:{
            zoom:15,//缩放等级
            center: [114.297511,30.706333],//中心点
        },
        markerConfig:{
            position: [114.297511,30.706333],//中心点
            draggable:false
        },
      requestHourse: {
        houseId: "",
        address: "",
        area: ""
      },
      label: [],
      // 房东要求
      demandList: [],
      // 轮播图
      carouselList: [],
      // 房东详情
      hourseInfo: [],
      // 地图信息
      mapInfo: [],
      // 评论信息
      commentList: [],
      // 查看大图
      srcList: [],
      // 评分
      value1: 5,
      zoom: 18,
      // 点的经纬度
      // markers: {
      //   lng: undefined,
      //   lat: undefined
      // },
      // 画框中间的经纬度和标记点
      frameCenter: {
        lat: "",
        lng: ""
      },
      // 切换
      activeName: "survey",
      activeNameother: "first",
        serveList:{
            children:[]
        }
    };
  },
  created() {
    var today = new Date();
    today.setTime(today.getTime());
    var todayStr =
      today.getFullYear() +
      "-" +
      (today.getMonth() + 1 > 9
        ? today.getMonth() + 1
        : "0" + (today.getMonth() + 1)) +
      "-" +
      today.getDate();
    var tomorrow = new Date();
    tomorrow.setTime(tomorrow.getTime() + 24 * 60 * 60 * 1000);
    var tomorrowStr =
      tomorrow.getFullYear() +
      "-" +
      (tomorrow.getMonth() + 1 > 9
        ? tomorrow.getMonth() + 1
        : "0" + (tomorrow.getMonth() + 1)) +
      "-" +
      tomorrow.getDate();

    this.requestHourse = {
      houseId: sessionStorage.getItem("houseId"),
      address: todayStr,
      area: tomorrowStr
    };
    this.houseListInfoAjax();
  },
    beforeDestroy() {
        this.$refs.mapContainer.destroyMap();
    },
    methods: {
    handleClick(tab, event) {
      console.log(tab, event);
      window.document.getElementById(`${tab.name}`).scrollIntoView({
        behavior: "smooth",
        block: "start",
        alignTo: "true",
        inline: "start"
      });
    },
    // 获取地图经纬度
    // gainAddress(cityValue) {
    //   this.$jsonp("http://api.map.baidu.com/geocoding/v3/", {
    //     address: cityValue,
    //     output: "json",
    //     ak: "gYOBOyROwCVTPTZavwZ6GumDClyRSjhB"
    //   })
    //     .then(res => {
    //       console.log(res);
    //       this.markers.lng = res.result.location.lng;
    //       this.markers.lat = res.result.location.lat;
    //       this.frameCenter = res.result.location;
    //     })
    //     .catch(err => {
    //       console.log(err);
    //     });
    // },
    // 查看沟通日志图片
    getImg(item) {
      this.srcList = [];
      this.srcList.push(item);
    },
    // 查看图片
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible_img = true;
    },
    // 获取详细信息
    async houseListInfoAjax() {
      const { data: res } = await houseListInfo(this.requestHourse);
      if(res.code==200){
          this.hourseInfo = res.data.hourseInfo;
          console.log(this.hourseInfo,this.hourseInfo.houseInfoSon)
          this.mapInfo = res.data.mapInfo;
          this.commentList = res.data.commentList;
          this.frameCenter = {
              lat: res.data.hourseInfo.latitude,
              lng: res.data.hourseInfo.longtitude
          };
          this.mapConfig.center=[res.data.hourseInfo.longtitude, res.data.hourseInfo.latitude];
          this.markerConfig.position=this.mapConfig.center;
          this.$nextTick(()=>{
              //初始化地图
              this.$refs.mapContainer.init();
          })
          this.label = res.data.label;
          if(res.data.serviceList[0]){
              this.serveList =res.data.serviceList[0];
          }


          this.demandList = res.data.CheckInNotes;
          this.demand = res.data.hourseInfo?.params?.configList;
          this.carouselList = [
              ...(res.data.hourseInfo?.houseInfoSon?.vCoverPics || ""), //1
              ...(res.data.hourseInfo?.houseInfoSon?.vBedrooms || ""), //1
              ...(res.data.hourseInfo?.houseInfoSon?.vGalleryPics || ""), //1
              ...(res.data.hourseInfo?.houseInfoSon?.vKitchenPics || ""), //vKitchenPics
              ...(res.data.hourseInfo?.houseInfoSon?.vSaloonPics || ""), //vSaloonPics
              ...(res.data.hourseInfo?.houseInfoSon?.vToiletPics || ""), //vToiletPics
              ...(res.data.hourseInfo?.houseInfoSon?.vOtherPics || "")
          ];
      }

      // this.gainAddress(this.cityValue);
    }
  }
};
</script>

<style lang="less" scoped>
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 420px;
  margin: 0;
  border-radius: 10px;
  height: 421px;

  /deep/ .el-image {
    height: 100%;
    width: 100%;
  }
}
.el-carousel__button {
  width: 20px;
  height: 20px;
}
.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
  border-radius: 10px;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #e0e0e0;
  border-radius: 10px;
}
.carouselList {
  margin-top: 32px;
  // width: 1192px;
  height: 454px;
}
.tabsList {
  height: 52px;
  // width: 1895px;
  // position: fixed;
  // top: 118px;
  // left: 223px;

  // z-index: 55;
  // background-color: #fff;
}
.detailsList {
  width: calc(100%  / 2 + 100px);
  .details_top {
    padding: 20px 8px 30px 36px;
    min-height: 230px;
    border-bottom: 10px solid #e1e1e1;
    .details_title {
      font-weight: bold;
      font-size: 14px;
    }
    .details_name {
      font-weight: bold;
      font-size: 24px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .details_tag {
      margin-top: 12px;
      min-height: 32px;
      .el-tag {
        margin-right: 24px;
        margin-bottom: 20px;
      }
    }
    .details_info {
      margin-top: 30px;
      height: 60px;
      font-size: 16px;
      color: #333333;
      .details_info_left {
        float: left;
        .details_info_left_l {
          float: left;
          img {
            width: 60px;
            height: 60px;
            margin-right: 8px;
          }
        }
        .details_info_left_r {
          float: left;
          line-height: 16px;
          .details_info_left_r_top {
            text-align: center;
            margin-top: 9px;
            margin-bottom: 4px;
          }
        }
      }
      .details_info_center {
        height: 60px;
        float: left;
        margin-left: 95px;
        .details_info_center_l {
          float: left;
          img {
            width: 60px;
            height: 60px;
            margin-right: 8px;
          }
        }
        .details_info_center_r {
          float: left;
          line-height: 16px;
          .details_info_center_r_top {
            text-align: center;
            margin-top: 9px;
            margin-bottom: 4px;
          }
        }
      }
      .details_info_right {
        float: left;
        height: 60px;
        margin-left: 95px;
        .details_info_right_l {
          float: left;
          img {
            width: 60px;
            height: 60px;
            margin-right: 8px;
          }
        }
        .details_info_right_r {
          float: left;
          line-height: 16px;
          .details_info_right_r_top {
            text-align: center;
            margin-top: 9px;
            margin-bottom: 4px;
          }
        }
      }
    }
  }
  .details_bottom {
    padding: 20px 8px 30px 36px;
    border-bottom: 10px solid #e1e1e1;
    .discounts_title {
      font-weight: bold;
      font-size: 24px;
    }
    .discounts_list {
      white-space: nowrap;

      overflow: hidden;
      text-overflow: ellipsis;
      width: 706px;
      height: 48px;
      line-height: 48px;
      .discounts_list_left {
        float: left;
        .el-tag.el-tag--danger {
          width: 72px;
          line-height: 26px;
          height: 28px;
        }
      }
      .discounts_list_right {
        margin-left: 15px;
        float: left;
        line-height: 46px;
        font-size: 18px;
        color: #666666;
      }
    }
  }
  .landlord {
    padding: 20px 23px 20px 36px;
    border-bottom: 10px solid #e1e1e1;
    .landlord_title {
      font-weight: bold;
      font-size: 24px;
    }
    .landlord_info {
      height: 72px;
      margin-top: 17px;
      .landlord_info_img {
        float: left;
        width: 72px;
        height: 72px;
        border-radius: 50%;
        margin-right: 12px;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .landlord_info_text {
        padding-top: 6px;
        height: 72px;
        float: left;
        width: 186px;
        .landlord_info_text_top {
          font-size: 18px;
          margin-bottom: 15px;
        }
        .landlord_info_text_bottom {
          font-size: 16px;
          color: #666666;
        }
      }
      .landlord_info_grade {
        float: left;
        width: 350px;
        margin-left: 70px;
        padding-top: 6px;
        .landlord_info_grade_top {
          display: flex;
          .grade_top_list {
            font-size: 14px;
            flex: 1;
            text-align: center;
          }
        }
        .landlord_info_grade_bottom {
          margin-top: 15px;
          display: flex;
          .grade_bottom_list {
            font-size: 18px;
            flex: 1;
            text-align: center;
          }
        }
      }
    }
  }
  .housing_location {
    padding: 20px 0 0 36px;
    .housing_location_title {
      font-weight: bold;
      font-size: 24px;
      margin-bottom: 20px;
    }
    .housing_location_map {
      position: relative;
      width: 714px;
      height: 380px;
      .map {
        width: 100%;
        height: 380px;
      }
      .housing_location_map_box {
        padding: 10px 25px 16px 20px;
        top: 5px;
        right: 5px;
        position: absolute;
        width: 310px;
        height: 370px;
        border-radius: 6px;
        background-color: #fff;
        .housing_location_map_box_title {
          font-size: 16px;
          .housing_location_map_box_title_bottom {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
        .housing_location_map_box_tabs {
          overflow: hidden;
          height: 300px;
          // position: absolute;
          // width: 300px;
          margin-top: 8px;
        }
      }
    }
  }
  .firstList {
    height: 50px;
    .firstList_top {
      height: 20px;
      .firstList_top_left {
        float: left;
        width: 20px;
        height: 20px;
        text-align: center;
        line-height: 20px;
        color: #fff;
        font-size: 14px;
        background-color: #f6b239;
        border-radius: 50%;
        margin-right: 10px;
      }
      .firstList_top_right {
        float: left;
        height: 20px;
        line-height: 20px;
      }
    }
    .firstList_bottom {
      margin-top: 5px;
      font-size: 12px;
      margin-left: 30px;
      color: #999999;
    }
  }
  .evaluate {
    margin-top: 50px;
    padding: 0 0 0 36px;
    .evaluate_title {
      font-weight: bold;
      font-size: 24px;
    }
    .evaluate_info {
      position: relative;
      height: 132px;
      margin-top: 17px;
      border-bottom: 1px solid #e1e1e1;
      .evaluate_info_img {
        float: left;
        width: 64px;
        height: 64px;
        border-radius: 50%;
        margin-right: 12px;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .evaluate_info_text {
        padding-top: 6px;
        height: 64px;
        float: left;
        .evaluate_info_text_top {
          font-size: 18px;
          margin-bottom: 8px;
        }
        .evaluate_info_text_bottom {
          font-size: 16px;
          color: #666666;
        }
      }
      .evaluate_info_grade {
        float: left;
        width: 360px;
        margin-left: 150px;
        padding-top: 6px;
        .evaluate_info_grade_top {
          padding-left: 26px;
          height: 42px;
          .grade_top_list {
            width: 42px;
            height: 42px;
            background-color: #ededed;
            border-radius: 50%;
            float: left;
            text-align: center;
            line-height: 42px;
            margin-right: 48px;
            font-weight: bold;
            font-size: 16px;
            color: #666666;
          }
          .grade_top_list:nth-last-child(1) {
            margin: 0;
          }
        }
        .evaluate_info_grade_bottom {
          margin-top: 10px;
          display: flex;
          .grade_bottom_list {
            font-size: 18px;
            flex: 1;
            text-align: center;
          }
        }
      }
      .evaluate_total {
        position: absolute;
        bottom: 15px;
        left: 0px;
        height: 24px;
        font-size: 18px;
      }
    }
    .evaluate_list_box {
      padding: 0px 20px 20px 0px;
      .evaluate_list {
        margin-top: 15px;
        padding: 1px 0;
        .evaluate_list_userinfo {
          height: 64px;
          .evaluate_list_userinfo_text {
            width: 250px;
            float: left;
            height: 64px;
            .evaluate_list_userinfo_photo {
              float: left;
              width: 64px;
              height: 64px;
              border-radius: 50%;
              overflow: hidden;
              img {
                width: 100%;
                height: 100%;
              }
            }
            .evaluate_list_userinfo_name {
              position: relative;
              float: left;
              margin-left: 12px;
              padding-top: 6px;
              .evaluate_list_userinfo_name_top {
                font-size: 18px;
                margin-bottom: 8px;
              }
              .evaluate_num {
                position: absolute;
                font-size: 16px;
                color: #666666;
                top: 37px;
                left: 120px;
              }
            }
          }
          .evaluate_list_userinfo_time {
            float: right;
            font-size: 18px;
            color: #333333;
          }
        }
        .evaluate_text {
          margin-top: 10px;
          padding: 1px 0;
          font-size: 14px;
        }
        .evaluate_photos {
          margin-top: 15px;
          height: 64px;
          .QuickMark {
            float: left;
            margin-right: 12px;
            width: 64px;
            height: 64px;
          }
        }
      }
    }
  }
  .more {
    height: 20px;
    text-align: center;
    font-size: 12px;
    color: #666666;
    background-color: #ededed;
    line-height: 20px;
    margin-left: 36px;
  }
  /deep/.image-slot {
    height: 64px;
    line-height: 64px;
    text-align: center;
  }
}
.facility {
  padding: 40px 0 0 36px;
  .facility_title {
    font-weight: bold;
    font-size: 24px;
    margin-bottom: 20px;
  }
  .facility_list {
    position: relative;
    min-height: 128px;
    padding: 1px;
    overflow: hidden;
    .facility_list_left {
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 60px;
      .img {
        width: 60px;

        // position: absolute;
        // top: 50%;
        // left: 50%;
        // trasnsform: translate(-50%, -50%);
        img {
          width: 60px;
          height: 60px;
        }
        .img_text {
          margin-top: 5px;
          text-align: center;
          font-size: 14px;
        }
      }
    }
    .facility_list_right {
      margin-left: 110px;
      margin-top: 20px;
      float: left;
      .facility_list_rightList_box {
        float: left;

        .facility_list_rightList {
          float: left;
          width: 185px;
          height: 64px;
          .rightList_left {
            float: left;
            width: 24px;
            height: 24px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .rightList_right {
            float: left;
            margin-left: 15px;
            font-size: 18px;
            color: #333333;
          }
        }
      }
    }
  }
}
.service {
  padding: 40px 0 0 36px;
  .service_title {
    font-weight: bold;
    font-size: 24px;
    margin-bottom: 20px;
  }
  .unsubscribe {
    float: left;
    font-size: 16px;
    color: #666666;
    span {
      display: inline-block;
      width: 27px;
    }
  }
  .service_rule_list_info_title {
    margin-left: 10px;
    font-size: 16px;
    height: 24px;
  }
  .service_rule {
    .service_rule_list_one {
      height: 203px;
      .service_rule_list_one_info {
        float: left;
        .service_rule_list_info_title {
          margin-left: 10px;
          font-size: 16px;
          height: 24px;
          .GS {
            width: 48px;
            height: 24px;
            line-height: 22px;
            font-size: 14px;
            background: #219653;
            border-radius: 4px;
            color: #fff;
            border: 1px solid #219653;
          }
          .SZ {
            width: 48px;
            height: 24px;
            line-height: 22px;
            font-size: 14px;
            background: #2694fa;
            border-radius: 4px;
            color: #fff;
            border: 1px solid #2694fa;
          }
          .YG {
            width: 48px;
            height: 24px;
            line-height: 22px;
            font-size: 14px;
            background: #f43d3d;
            border-radius: 4px;
            color: #fff;
            border: 1px solid #f43d3d;
          }
        }
        .img {
          margin-top: 15px;
          margin-left: 10px;
          width: 640px;
          height: 134px;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
    .service_rule_list_two {
      height: 24px;
      .service_rule_list_two_info {
        float: left;
      }
    }
    .service_rule_list_three {
      margin-top: 15px;
      height: 24px;
      .service_rule_list_three_info {
        float: left;
      }
    }
    .service_rule_list_four {
      margin-top: 15px;
      height: 48px;
      .service_rule_list_four_info {
        float: left;
        .invoice {
          margin-left: 10px;
          font-size: 16px;
          color: #219653;
        }
        .invoice_bottom {
          margin-top: 5px;
          height: 21px;
          font-size: 16px;
          line-height: 21px;
          margin-left: 10px;
          span {
            color: #2694fa;
          }
        }
      }
    }
    .service_rule_list_five {
      margin-top: 21px;
      padding: 1px;
      overflow: hidden;
      .service_rule_list_five_info {
        width: 638px;
        padding-top: 3px;
        margin-left: 10px;
        float: left;
        min-height: 32px;
        .five_info_list {
          float: left;
          width: 210px;
          height: 32px;
          .five_info_list_left {
            float: left;
            width: 20px;
            height: 20px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .five_info_list_right {
            float: left;
            margin-left: 10px;
            font-size: 14px;
          }
        }
      }
      .notes {
        margin-top: 10px;
        float: left;
        margin-left: 74px;
        font-size: 14px;
      }
    }
  }
}
.explain {
  padding: 40px 0 0 36px;
  padding-bottom: 20px;
  border-bottom: 10px solid #ededed;
  .explain_title {
    font-weight: bold;
    font-size: 24px;
    margin-bottom: 20px;
  }
  .explain_text {
    font-size: 16px;
  }
}
.good_house {
  overflow: hidden;
  padding: 40px 0 0 36px;
  padding-bottom: 100px;
  .good_house_title {
    font-weight: bold;
    font-size: 24px;
    margin-bottom: 20px;
  }
  .good_house_list {
    float: left;
    margin-right: 10px;
    width: 171px;
    height: 210px;
    overflow: hidden;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
    border-radius: 6px;
    .good_house_list_img {
      width: 171px;
      height: 100px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .good_house_info {
      padding-left: 5px;
      margin-top: 8px;
      height: 16px;
      line-height: 16px;
      font-size: 12px;
      color: #666666;
    }
    .good_house_info_name {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      display: -moz-box;
      -moz-line-clamp: 2;
      -moz-box-orient: vertical;
      word-wrap: break-word;
      word-break: break-all;
      white-space: normal;
      margin-top: 8px;
      padding-left: 5px;
      font-size: 14px;
      color: #000000;
    }
    .price {
      margin-top: 8px;
      color: #f62a2a;
      font-size: 20px;
      font-weight: bold;
      span {
        font-size: 12px;
      }
    }
    .priceOther {
      display: inline-block;
      font-size: 12px;
      color: #666666;
      text-decoration: line-through;
    }
  }
  .good_house_list:nth-last-child(1) {
    margin-right: 0px;
  }
}
/deep/.el-tabs__item.is-active {
  color: #000000;
  font-size: 18px;
}
/deep/.el-tabs__item {
  color: #666666;
  font-size: 18px;
}
/deep/.el-tabs__active-bar {
  background-color: #f6b439;
}
/deep/.el-tabs__item:hover {
  color: #000000;
}
</style>
